/** Shared metric value / threshold display for Gate 2 scorecard and summary. */

export function formatMetricValue(value, unit) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const n = Number(value);
  if (unit === "fraction" || unit === "rate") {
    const fraction = n > 1 ? n / 100 : n;
    return `${(fraction * 100).toFixed(1)}%`;
  }
  if (unit === "score_5") {
    return `${n.toFixed(1)}/5`;
  }
  return n.toFixed(3);
}

export function formatMetricThreshold(threshold, direction, unit) {
  return formatExpectedForScorecard(threshold, direction, unit);
}

/** Cleaner threshold line for table "Expected" column (Figma). */
export function formatExpectedForScorecard(threshold, direction, unit) {
  if (threshold == null || !Number.isFinite(Number(threshold))) return "—";
  const n = Number(threshold);
  const symbol =
    direction === "gte" ? "≥" : direction === "lte" ? "≤" : direction === "lt" ? "<" : direction === "gt" ? ">" : "=";
  if (unit === "fraction" || unit === "rate") {
    const pct = n > 1 ? n : n * 100;
    return `${symbol} ${pct % 1 === 0 ? pct.toFixed(0) : pct.toFixed(1)}%`;
  }
  if (unit === "score_5") {
    return `${symbol} ${n.toFixed(1)}/5`;
  }
  return `${symbol} ${n}`;
}

export function formatActualForScorecard(result) {
  if (result?.error || result?.value == null || !Number.isFinite(Number(result.value))) {
    return result?.error ? "Not evaluated" : "—";
  }
  return formatMetricValue(result.value, result.unit);
}

export function scorecardUnevaluatedDetail(result) {
  const msg = String(result?.error || "").trim();
  return msg || null;
}

export function rowStatus(result) {
  if (result?.error || result?.value == null || result?.passed == null) {
    return { key: "unevaluated", label: "Not evaluated" };
  }
  return result.passed
    ? { key: "passed", label: "Passed" }
    : { key: "failed", label: "Failed" };
}
